import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "shareMobileFacebook",
  "use": "shareMobileFacebook-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 36 36\" xmlns=\"http://www.w3.org/2000/svg\" id=\"shareMobileFacebook\"><path d=\"m18 36c9.9411 0 18-8.0589 18-18 0-9.94113-8.0589-18-18-18-9.94113 0-18 8.05887-18 18 0 9.9411 8.05887 18 18 18z\" fill=\"#9c7446\" /><path d=\"m15.5616 15.098v-1.7419c0-2.671 1.8581-4.64516 4.2968-4.64516h2.7871v3.36776h-2.7871c-.2323 0-.6968.4645-.6968 1.1613v1.858h3.4839v3.4839h-3.4839v8.4774h-3.4839v-8.4774h-2.7871v-3.4839z\" fill=\"#f6efeb\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol